import db from "../db";
import Constants from "../constants";
import * as Helpers from "../helpers";
import Vuex from "vuex";

export default {
  data() {
    return {
      processing: false,
      error: false,
      errorValue: 0,
      offerta: null,
      selected: null,
      loading: false,
      processingAnnulla: false,
      waitingForNumpad: false,
    };
  },
  watch: {
    offerta() {
      this.error = false;
      this.errorValue = 0;
    },
    processing(val) {
      this.loading = val;
    },
    selected(val, oldVal) {
      if (oldVal != null && val != oldVal) {
        this.offerta = null;
      }
    },
    calciatoreInAsta(val, oldVal) {
      if (val != oldVal) {
        this.resetAssegnaForm();
      }
    },
  },
  methods: {
    resetAssegnaForm() {
      this.selected = null;
      this.offerta = null;
      this.error = false;
      this.errorValue = 0;
      this.waitingForNumpad = false;
    },
    selectedClass(id) {
      return {
        selected: this.selected == id && !this.squadraDisabled(id),
      };
    },
    squadraDisabled(id) {
      return !!this.squadraDisabledReason(id);
    },
    squadraDisabledReason(id) {
      if (!_.find(this.asta_squadre_active, { id: id })) {
        return "Fuori dall'asta";
      }

      let calciatore = this.calciatore(this.asta_round.calciatoreInAsta);
      let regole_lega = this.asta_info.lega;
      let crediti_min =
        this.offerta == null ? Constants.OFFERTA.MINIMA : this.offerta;
      let squadra = this.asta_squadre[id];
      return Helpers.canJoinRoundWithReason(
        regole_lega,
        squadra,
        calciatore,
        crediti_min
      ).reason;
    },
    select(id) {
      this.selected = id;
    },
    showNumpad() {
      if (this.selected == null) {
        this.errorToast("Seleziona prima la squadra", "Poi scegli il costo");
        return;
      }

      this.waitingForNumpad = true;
      db.emit("numpad", {
        min: this.minOfferta,
        max: this.maxOffertaNumpad,
      });
    },
    setOffertaDaNumpad(value) {
      if (!this.waitingForNumpad) {
        return;
      }

      this.offerta = value;
      this.waitingForNumpad = false;
    },
    async annullaSelezione() {
      if (this.processing || this.processingAnnulla) {
        return;
      }

      this.processingAnnulla = true;
      let calciatoreInAsta = this.asta_round.calciatoreInAsta;
      try {
        await this.astaLogCalciatoreInAstaAnnullato(calciatoreInAsta);
        await db.resetRound(this.user_uid, true);
      } catch (err) {
        console.log(err);
        this.errorToast("Errore", "Impossibile annullare la selezione");
      } finally {
        this.resetAssegnaForm();
        this.processingAnnulla = false;
      }
    },
    async assegna() {
      if (this.processing) {
        return;
      }
      this.processing = true;
      if (this.offerta < this.minOfferta || this.offerta > this.maxOfferta) {
        this.error = true;
        this.errorValue = this.offerta;
        this.processing = false;
        return;
      }
      await this.wait(1000);
      let calciatoreInAsta = this.asta_round.calciatoreInAsta;
      let squadra_id = this.selected;
      let prezzo = this.offerta;
      try {
        await db.assegnaCalciatore(calciatoreInAsta, squadra_id, prezzo);
        await this.astaLogAssign(calciatoreInAsta, squadra_id, prezzo);
        await this.wait(1000);
        await this.deactivateSquadra(squadra_id);
        await db.updateCounter();
        await db.resetRound(this.user_uid);
      } catch (err) {
        console.log(err);
        await db.resetRound(this.user_uid, true);
      } finally {
        this.resetAssegnaForm();
        this.processing = false;
      }
    },
    async scarta() {
      if (this.processing) {
        return;
      }
      this.processing = true;
      await this.wait(1000);
      let calciatoreInAsta = this.asta_round.calciatoreInAsta;
      try {
        await db.scartaCalciatore(calciatoreInAsta);
        await this.astaLogScartato(calciatoreInAsta);
        await this.wait(1000);
        await db.updateCounter();
        await db.resetRound(this.user_uid);
      } catch (err) {
        console.log(err);
        await db.resetRound(this.user_uid, true);
      } finally {
        this.resetAssegnaForm();
        this.processing = false;
      }
    },
    squadra(id) {
      return this.asta_squadre[id];
    },
  },
  computed: {
    canAssegnaAct() {
      return this.admin && this.mode_assegna && this.is_calciatore_in_asta;
    },
    calciatoreInAsta() {
      return this.asta_round.calciatoreInAsta;
    },
    nomeCalciatoreInAsta() {
      return this.calciatoreInAstaInfo
        ? this.calciatoreInAstaInfo.calciatore
        : "calciatore";
    },
    nomeClubCalciatoreInAsta() {
      return this.calciatoreInAstaInfo
        ? this.calciatoreInAstaInfo.nomeClub
        : "";
    },
    ruoloCalciatoreInAsta() {
      return this.calciatoreInAstaInfo
        ? this.calciatoreInAstaInfo.ID_Ruolo
        : null;
    },
    calciatoreInAstaInfo() {
      return this.calciatore(this.calciatoreInAsta);
    },
    minOfferta() {
      return Constants.OFFERTA.MINIMA;
    },
    maxOfferta() {
      return this.squadra(this.selected)
        ? this.squadra(this.selected).max_offerta
        : Constants.OFFERTA.MINIMA;
    },
    maxOffertaNumpad() {
      return this.selected ? this.maxOfferta : Constants.OFFERTA.MINIMA;
    },
    squadreDropdown() {
      return _.map(this.asta_squadre_array, (sq) => {
        let squadra = this.squadra(sq.id) || {};
        return {
          id: sq.id,
          name: sq.name,
          pic: squadra.pic,
          disabledReason: this.squadraDisabledReason(sq.id),
          disabled: this.squadraDisabled(sq.id),
        };
      });
    },
    canAnnullaSelezione() {
      return this.admin && this.mode_assegna && this.is_calciatore_in_asta;
    },
    ...Vuex.mapGetters([
      "asta_squadre_array",
      "asta_squadre_active",
    ]),
  },
};
